import { confirmAlert } from 'react-confirm-alert'; // Import
import React, { useState, useEffect, useRef } from 'react';
import { Modal, ModalBody, Button } from 'react-bootstrap';




function PopupReqCntrl(props) {
    console.log(props);
    
    const [TimeOut, setTimeOut] = useState(props.TimeOut);

    useEffect(() => {
        console.log('TimeOut', TimeOut);
        const interval = setInterval(() => {
            let t = TimeOut;
            t = t - 1000;
            if(t == 0){
                props.handleReqCntrlReply(true, props.SessionRefForPopUp)
            }
            setTimeOut(t);
    }, 1000)

    return () => clearInterval(interval);
    }
    ,[TimeOut]);

    return ( 
    <>
    {
    <Modal show={true}>
        <ModalBody>
        <div style={{display:'flex', justifyContent:'center', alignItems:'center', flexDirection:'column'}}>
            {`Request Control, Timeout: ${parseInt(TimeOut) / 1000} seconds`}
            <Button onClick={() => props.handleReqCntrlReply(true, props.SessionRefForPopUp)}>
                Accept Control
            </Button>
            <Button  onClick={() => props.handleReqCntrlReply(false, props.SessionRefForPopUp)}>
                Deny Control
            </Button>
        </div>
        </ModalBody>
    </Modal>
    }
    </> );
}

export default PopupReqCntrl;